import {ReactNode} from 'react';
import {Characters} from './Characters';
import {ContentGuide} from './ContentGuide';
import {DetailInfo} from './DetailInfo';
import {ItemList} from './ItemList';
import {Keywords} from './Keywords';
import {NewsWithLine} from './NewsWithLine';
import {Screenshot} from './Screenshot';
import {Summary} from './Summary';

function ContentHomeSectionBodyMain({children}: {children: ReactNode}) {
  return (
    <div className="flex w-full flex-col items-center overflow-hidden">
      {children}
    </div>
  );
}

export const ContentHomeSectionBody = Object.assign(
  ContentHomeSectionBodyMain,
  {
    Summary,
    ContentGuide,
    DetailInfo,
    Keywords,
    Characters,
    Screenshot,
    ItemList,
    NewsWithLine,
  }
);
